import React from 'react'
import NavMenu from '../NavMenu'
import { Container } from "@bsf/force-ui";
import Modules from '../Dashboard/Modules';
import QuickAccess from '../Dashboard/QuickAccess';
import Explore from '../Dashboard/Explore';
import ElementsFont from './ElementsFont';
import ElementModules from './ElementModules';
import ExtendWebsite from '../Dashboard/ExtendWebsite';

const Elements = () => {
    return (
        <>
            <NavMenu />
            <div>
                <Container
                    align="stretch"
                    className="p-6 flex flex-col lg:flex-row box-border"
                    containerType="flex"
                    direction="row"
                    gap="sm"
                    justify="start"
                    style={{
                        width: "100%",
                    }}
                >
                    <Container.Item
                        className="p-2 uavc-65-width"
                        alignSelf="auto"
                        order="none"
                        shrink={1}
                    >
                        <ElementModules/>
                    </Container.Item>
                    <Container.Item
                        className="p-2 uavc-35-width"
                        shrink={1}
                    >
                        <ElementsFont />
                        <div className="pt-5">
                        <ExtendWebsite />
                        </div>
                        <div className="pt-5">
                        <QuickAccess />
                        </div>
                        {/* <div className="pt-5">
                            <Explore />
                        </div> */}

                    </Container.Item>
                </Container>
            </div>
        </>
    )
}

export default Elements
